import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class AssassinsHideout2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.ASSASINS_HIDEOUT2;
}

export default AssassinsHideout2PoiTileEntity;
